import { Document } from '@tiptap/extension-document';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Text } from '@tiptap/extension-text';
export const textEditorExtensions = [Document.extend({
  content: 'paragraph'
}), Paragraph, Text];